module.exports = __webpack_public_path__ + "static/media/EYInterstate-Light.a0cf44cc.svg";